import {SET_DISCOUNT_CAPPED_STATE} from "../store/mutation-types";

export default {
	props: [ "receiptLine", "orderLine"],
	computed: {
		getDiscountLineFromOrder() {
			if(this.pendingOrder) {
				return this.pendingOrder.orderLines.find((ol) => ol.name === "Total Rabat");
			}
			return null;
		},
		getGlobalDiscountPriceRuleId() {
			const orderLine = this.orderLine ? this.orderLine : this.getDiscountLineFromOrder;
			return orderLine
				&& orderLine.options
				&& orderLine.options.appliedPriceRule
				&& orderLine.options.appliedPriceRule.options
				&& orderLine.options.appliedPriceRule.options.label === "CartDiscount"
				&& orderLine.options.appliedPriceRule.id;
		},
		getGlobalDiscountDisplayLabel() {
			const orderLine = this.orderLine ? this.orderLine : this.getDiscountLineFromOrder;
			return orderLine
				&& orderLine.options
				&& orderLine.options.appliedPriceRule
				&& orderLine.options.appliedPriceRule.options
				&& orderLine.options.appliedPriceRule.options.displayLabel;
		},
		extractlabelFromTag() {
			const self = this;
			if(!self.receiptLine) {
				return "";
			}

			return self.receiptLine.tags.length > 0 && self.receiptLine.tags[0];
		},
		extractDiscountMessageFromTag() {
			const self = this;
			if(!self.receiptLine) {
				return "";
			}

			const tags = self.receiptLine.tags.length > 0 && self.receiptLine.tags.slice(1);
			if(
				self.receiptLine.tags
				&& self.receiptLine.tags.includes("DiscountCapped")
				&& (self.receiptLine.tags.includes("SunsetPlusBasic") || self.receiptLine.tags.includes("SunsetPlusBasicAnnual"))
				&& this.$store.getters.featureToggles.enableSunsetPlusDiscountLimitPopup
			) {
				this.$store.commit(SET_DISCOUNT_CAPPED_STATE, {
					discountCapped: "DiscountCapped",
					discountMax: this.getDiscountMax(),
					showModal: this.$store.getters.discountCapped && this.$store.getters.discountCapped.showModal !== undefined
						? this.$store.getters.discountCapped.showModal
						: true
				});
			} else {
				this.$store.commit(SET_DISCOUNT_CAPPED_STATE);
			}

			return tags;
		}
	},
	methods: {
		getDiscountMax() {
			return this.orderLine && this.orderLine.options && this.orderLine.options.appliedPriceRule &&
				this.orderLine.options.appliedPriceRule.options && this.orderLine.options.appliedPriceRule.options.discountMax;
		},
		isDiscountLine(line) {
			return ["FreeMeal", "Discount"].includes(line.type);
		},
		tagToLocalizedString(tag) {
			const self = this;
			const discountMax = this.orderLine && this.orderLine.options && this.orderLine.options.appliedPriceRule &&
				this.orderLine.options.appliedPriceRule.options && this.orderLine.options.appliedPriceRule.options.discountMax;
			switch(tag){
			case "Delivery": return "Delivery";
			case "SunsetPlusForEmployees": return self.$t("shopComponents.gt2.shoppingCart.orderDiscount.sunsetPlusForEmployees");
			case "SunsetPoints": return self.$t("shopComponents.gt2.shoppingCart.orderDiscount.sunsetPoints");
			case "SunsetPlusBasic": return self.$t("shopComponents.gt2.shoppingCart.orderDiscount.sunsetPlusBasic");
			case "SunsetPlusBasicAnnual": return self.$t("shopComponents.gt2.shoppingCart.orderDiscount.sunsetPlusBasic");
			case "SunsetPlusBusiness": return self.$t("shopComponents.gt2.shoppingCart.orderDiscount.sunsetPlusBusiness");
			case "SunsetPlusExclusive": return self.$t("shopComponents.gt2.shoppingCart.orderDiscount.sunsetPlusExclusive");
			case "SunsetPlusExclusiveAnnual": return self.$t("shopComponents.gt2.shoppingCart.orderDiscount.sunsetPlusExclusive");
			case "SunsetPlusPremium": return self.$t("shopComponents.gt2.shoppingCart.orderDiscount.sunsetPlusPremium");
			case "SunsetPlusPremiumAnnual": return self.$t("shopComponents.gt2.shoppingCart.orderDiscount.sunsetPlusPremium");
			case "Total Discount": return self.$t("shopComponents.gt2.shoppingCart.orderDiscount.totalDiscount");
			case "FreeMeal": return self.$t("shopComponents.gt2.shoppingCart.orderDiscount.freeMeal");
			case "CartDiscount": return self.getGlobalDiscountDisplayLabel || self.$t("shopComponents.gt2.shoppingCart.orderDiscount.cartDiscount");
			case "Voucher": return "Campaign code";
			case "DiscountCapped":
				if(self.extractlabelFromTag){
					switch (self.extractlabelFromTag) {
					case "SunsetPlusForEmployees": return self.$t("shopComponents.gt2.shoppingCart.orderDiscount.sunsetPlusForEmployeesMessage", { discountMaximum: discountMax || 500 });
					case "SunsetPlusBasic": return !self.$store.getters.featureToggles.enableSunsetPlusDiscountLimitPopup ? self.$t("shopComponents.gt2.shoppingCart.orderDiscount.sunsetPlusBasicMessage", { discountMaximum: discountMax || 150 }) : self.$t("shopComponents.gt2.shoppingCart.orderDiscount.sunsetPlusBasicMessageDiscountLimit", { discountMaximum: discountMax || 150 });
					case "SunsetPlusBasicAnnual": return self.$t("shopComponents.gt2.shoppingCart.orderDiscount.sunsetPlusBasicMessage", { discountMaximum: discountMax || 150 });
					case "SunsetPlusBusiness": return self.$t("shopComponents.gt2.shoppingCart.orderDiscount.sunsetPlusBusinessMessage", { discountMaximum: discountMax || 150 });
					case "SunsetPlusExclusive": return self.$t("shopComponents.gt2.shoppingCart.orderDiscount.sunsetPlusExclusiveMessage", { discountMaximum: discountMax || 600 });
					case "SunsetPlusExclusiveAnnual": return self.$t("shopComponents.gt2.shoppingCart.orderDiscount.sunsetPlusExclusiveMessage", { discountMaximum: discountMax || 600 });
					case "SunsetPlusPremium": return self.$t("shopComponents.gt2.shoppingCart.orderDiscount.sunsetPlusPremiumMessage", { discountMaximum: discountMax || 600 });
					case "SunsetPlusPremiumAnnual": return self.$t("shopComponents.gt2.shoppingCart.orderDiscount.sunsetPlusPremiumMessage", { discountMaximum: discountMax || 600 });
					case "SunsetPoints": return self.$t("shopComponents.gt2.shoppingCart.orderDiscount.sunsetPointsMessage", { discountMaximum: discountMax || 300 });
					case "CartDiscount": return self.$t("shopComponents.gt2.shoppingCart.orderDiscount.cartDiscountMessage", { discountMaximum: discountMax || 1000 });
					default: {
						if (self.extractlabelFromTag.startsWith("FreeMeal:")) {
							const voucherName = self.extractlabelFromTag.substring("FreeMeal:".length);
							return `${voucherName} price rule applied`;
						}
					}
					}
				}
				return self.$t("shopComponents.gt2.shoppingCart.orderDiscount.discountCapped");
			}
		}
	}
};
